// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ZoomUI__ZoomUI___274_y{align-items:center}.ZoomUI__ZoomInOut___12a_M,.ZoomUI__ZoomUI___274_y{display:flex;flex-direction:row}.ZoomUI__ZoomInOut___12a_M>div{margin-right:8px}.ZoomUI__PageViewModifiers___1Cr5r{display:flex;flex-direction:row}.ZoomUI__PageViewModifiers___1Cr5r>div{margin-right:8px}.ZoomUI__ModernZoomIn___o6qlx{margin-bottom:8px}.ZoomUI__LiquidMode____cQLm>*>button>svg{color:#fff;fill:#fff}.ZoomUI__ModernLiquidMode___33y8t{margin-top:8px}.ZoomUI__viewModeSwitcherPopover___2yW2W{}", ""]);
// Exports
exports.locals = {
	"ZoomUI": "ZoomUI__ZoomUI___274_y",
	"ZoomInOut": "ZoomUI__ZoomInOut___12a_M",
	"PageViewModifiers": "ZoomUI__PageViewModifiers___1Cr5r",
	"ModernZoomIn": "ZoomUI__ModernZoomIn___o6qlx",
	"LiquidMode": "ZoomUI__LiquidMode____cQLm",
	"ModernLiquidMode": "ZoomUI__ModernLiquidMode___33y8t",
	"viewModeSwitcherPopover": "ZoomUI__viewModeSwitcherPopover___2yW2W"
};
module.exports = exports;
